import {Feature} from "ol"
import {Tile as TileLayer, Vector as VectorLayer} from "ol/layer"
import {OSM, Vector as VectorSource, XYZ} from "ol/source"
import {LineString, Point, MultiPoint} from "ol/geom"
import {GeoJSON} from "ol/format"
import {Stroke, Style, Text} from "ol/style"
// import TileState from 'ol/TileState.js'

export const OSMLayer = new TileLayer({
	preload: Infinity,
	source: new OSM(),
  visible: false,
})

export const positionLayer = new VectorLayer({
  updateWhileAnimating: true,
	source: new VectorSource<Feature<Point | LineString>>({
		features: [],
	}),
  zIndex: 20000
})

export const neighbourLayer = new VectorLayer({
	source: new VectorSource<Feature<Point>>({
		features: []
	}),
	visible: false
})

export const routeLayer = new VectorLayer({
  updateWhileAnimating: true,
	source: new VectorSource<Feature<LineString | MultiPoint>>({
		features: []
	})
})

export const averageLayer = new VectorLayer({
  updateWhileAnimating: true,
	source: new VectorSource<Feature<LineString | MultiPoint>>({
		features: []
	})
})

export const tilesLayer = new TileLayer({
	visible: true,
  preload: Infinity,
	extent: [35.8972, 55.8267, 44.4917, 58.2278],
	minZoom: 13,
	maxZoom: 17,
  source: new XYZ({
    tileUrlFunction: (coords: number[]) => {
      const [z, x, y] = coords
      return `/tiles/${z}/${x}/${y}.png`
    }
  })
})

export const S57Layer = new TileLayer({
  preload: Infinity,
	minZoom: 4,
	maxZoom: 17,
  source: new XYZ({
    tileUrlFunction: (coords: number[]) => {
      const [z, x, y] = coords
      return `/world1/${z}/${x}/${y}.png`
    }
  })
})
